import React from "react";

export interface ListHeaderProps {
  header?: string;
  title?: string;
}

const ListHeader = ({ header, title }: ListHeaderProps) => {
  return (
    <div className="w-full">
      <div className="text-lg font-medium text-aqua">
        {header || "Sample Header"}
      </div>
      <div className="mt-2 text-5xl font-bold leading-none">
        {title || "Sample Title"}
      </div>
    </div>
  );
};

export default ListHeader;
